export const useFaqJsonld = (questions: MaybeRefOrGetter<{ question: string; answer: string }[] | undefined>) => {
	useJsonld(() => {
		const items = (toValue(questions) ?? []).filter((item) => item.question && item.answer)
		if (!items.length) return {}

		return {
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			mainEntity: items.map((item) => ({
				'@type': 'Question',
				name: item.question,
				acceptedAnswer: {
					'@type': 'Answer',
					text: item.answer,
				},
			})),
		}
	})
}
